module.exports = __webpack_public_path__ + "static/media/zastitni-znak-1.d3446fef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/fina-vaterpolo/zastitni-znak-1.jpg
// module id = 416
// module chunks = 0